import React from "react";

import Card from "../../components/Card";
import BreadCrumbNavigation from "../../components/DataTable/TopSection/BreadCrumbNavigation";
import * as S from "./styles";
import { SearchClientForm } from "../../components-v2/SearchClientForm";
import { LaunchAdjustmentForm } from "../../components-v2/LaunchAdjustmentForm";
import { useLaunchAdjustmentPage } from "./useLaunchAdjustmentPage";

function LaunchAdjustment() {
  const {
    formSteps,
    currentDoc,
    loadingBtn,
    clients,
    loadingTypes,
    typesAdjustments,
    selectedClient,
    hasPermissionToUsePreviousDate,
    currentMask,
    handleTab,
    handleResetSearch,
    handleStepOne,
    handleSaveAdjustment,
    onSelectClient,
  } = useLaunchAdjustmentPage();

  return (
    <S.Container data-testid="lancar-ajuste-page">
      <S.UserContainer>
        <BreadCrumbNavigation
          tableName="Lançar ajuste"
          preTableName="Vendas e Pagamentos"
        />
        <Card
          title="Lançar ajuste"
          list={undefined}
          modalContent={undefined}
          modalTitle={undefined}
          loading={undefined}
        >
          {formSteps === 0 && (
            <>
              <SearchClientForm
                currentDoc={currentDoc}
                currentMask={currentMask}
                onChangeTab={handleTab}
                onSubmit={handleStepOne}
                isSubmitting={loadingBtn}
              />
              {clients.length > 0 && (
                <S.ClientSelectionWrapper>
                  <h3>Selecione uma conta para lançar o ajuste:</h3>
                  <S.ClientSelectionItems>
                    {clients.map((client) => (
                      <S.CustomClientSelectionItem
                        client={{
                          id: client.id,
                          type: "titular",
                          name: client.name,
                          statusCliente: client.statusCliente,
                        }}
                        infosToShow={{
                          cpf: false,
                          id: true,
                          name: true,
                          statusCliente: true,
                        }}
                        onSelect={() => onSelectClient(client)}
                        isSelected={selectedClient?.id === client.id}
                      />
                    ))}
                  </S.ClientSelectionItems>
                </S.ClientSelectionWrapper>
              )}
            </>
          )}
          {formSteps === 1 && (
            <LaunchAdjustmentForm
              loadingTypes={loadingTypes}
              typesAdjustments={typesAdjustments}
              onSubmit={handleSaveAdjustment}
              onReset={handleResetSearch}
              clientInfo={{
                type: "titular",
                id: selectedClient?.id ?? "",
                name: selectedClient?.name ?? "",
                statusCliente: selectedClient?.statusCliente ?? "",
              }}
              hasPermissionToUsePreviousDate={hasPermissionToUsePreviousDate}
            />
          )}
        </Card>
      </S.UserContainer>
    </S.Container>
  );
}

export default React.memo(LaunchAdjustment);
